import { render } from "./AppControl.vue?vue&type=template&id=fba2c5e8"
import script from "./AppControl.vue?vue&type=script&lang=js"
export * from "./AppControl.vue?vue&type=script&lang=js"

import "./AppControl.vue?vue&type=style&index=0&id=fba2c5e8&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__